import { cloud, file_contract, office_buildings } from '@dnb/eufemia/icons';

import Tile from '@/components/Tile';
import useAuth from '@/hooks/useAuth';
import { useUser } from '@/hooks/useUser';

import ServicePage from '../../components/ServicePage';

export default function ApiExplorer() {
  const { isLoading: userLoading } = useUser();
  const { isInternal } = useAuth();
  return (
    <ServicePage title="API Explorer">
      <Tile icon={file_contract} linkTo="/explorer/apis/regulatory" title="Regulatory APIs" />
      <Tile icon={cloud} linkTo="/explorer/apis/commercial" title="Commercial APIs" />
      {isInternal && !userLoading && (
        <Tile icon={office_buildings} linkTo="/explorer/apis/internal" title="Internal APIs" />
      )}
    </ServicePage>
  );
}
